module.exports = __webpack_public_path__ + "img/GENERAL-BALENO-2.0c20c045.jpg";